
import setUpCanvas from './wk_ui/setUpCanvas';
import helper from './wk_ui/helper';
import './wk_ui/horizontalButtons';
import './wk_ui/stretchedLink';
import roundedTabs from './wk_ui/roundedTabs';
import setProcessedStatus from './wk_ui/setProcessedStatus';
import checkProcessedStatus from './wk_ui/checkProcessedStatus';

function WorkivaUI() {}

window.wk_ui = window.wk_ui || new WorkivaUI();

WorkivaUI.prototype.setUpCanvas = setUpCanvas;
WorkivaUI.prototype.helper = new helper();
WorkivaUI.prototype.roundedTabs = roundedTabs();
WorkivaUI.prototype.setProcessedStatus = setProcessedStatus;
WorkivaUI.prototype.checkProcessedStatus = checkProcessedStatus;

export default WorkivaUI;
